import React, { FC, useEffect, useState } from 'react';
import { Modal, Radio, Space, Typography, Button } from 'antd';
import { ViewLabel } from 'models/view-labels';

interface IProps {
  isModalOpen: boolean;
  handleCancel: () => void;
  handleOk: (acceptedId: string | null) => void;
  viewLabels: ViewLabel[];
  initialAcceptedId?: string | null;
}

const AcceptModal: FC<IProps> = ({
  isModalOpen,
  handleCancel,
  handleOk,
  viewLabels,
  initialAcceptedId = null,
}) => {
  const [selectedId, setSelectedId] = useState<string | null>(initialAcceptedId);

  useEffect(() => {
    if (isModalOpen) {
      setSelectedId(initialAcceptedId ?? null);
    }
  }, [isModalOpen, initialAcceptedId]);

  return (
    <Modal
      title="Select View Label to Accept"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <div>
          <Typography.Text type="secondary">
            Only one view label can be accepted. All other view labels will be rejected
            automatically.
          </Typography.Text>
        </div>

        <Radio.Group
          value={selectedId ?? ''}
          onChange={e => setSelectedId(e.target.value || null)}
          style={{ width: '100%' }}
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            {viewLabels.map(vl => (
              <Radio key={vl.uuid} value={vl.uuid}>
                <div>
                  <Typography.Text strong>{vl.viewClass?.view}</Typography.Text>
                  <div style={{ fontSize: 12, color: '#666' }}>
                    {vl.uuid}
                    {vl.isRejected && ' (Currently Rejected)'}
                  </div>
                </div>
              </Radio>
            ))}
          </Space>
        </Radio.Group>

        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" disabled={!selectedId} onClick={() => handleOk(selectedId)}>
            Accept
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};

export default AcceptModal;
